module.exports = __webpack_public_path__ + "static/media/9-6.22cb0db5.mp3";